import CheckListService from "../services/CheckListService";
import ScenarioService from "../services/ScenarioService";
import { InterviewApplied } from "../types/Interview";

/** Publica os artefatos gerados pela Entrevista, preservando os já publicados. */
export default async function publicarAplicados(applied: InterviewApplied): Promise<void> {
  if (applied.checklist_id !== null) {
    const checklist = await CheckListService.get(applied.checklist_id);
    if (checklist.data.status !== "published") {
      await CheckListService.publish(applied.checklist_id);
    }
  }

  if (applied.scenario_id !== null) {
    const scenario = await ScenarioService.getScenarioById(applied.scenario_id);
    if (scenario.data.status !== "published") {
      await ScenarioService.publish(applied.scenario_id);
    }
  }
}
